import React, { useContext } from 'react'
import { Route, Redirect } from 'react-router-dom'
import AuthContext from '../../context/auth/AuthContext'
import PreLoader from '../layouts/PreLoader'
import Cookie from 'js-cookie'

const PrivateRoute = ({ component: Component, ...rest }) => {

    const authContext = useContext(AuthContext)

    const { loading } = authContext
    const isAuthenticated = Cookie.get('token') ? true : false
    console.log(isAuthenticated, loading)

    return (
        <Route {...rest} render={
            props => {
                if (isAuthenticated)
                    return <Component {...props} />
                else if(!isAuthenticated)
                    return <Redirect to="/login" />
            }
        }>
        </Route>
    )
}

export default PrivateRoute